import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {useCookies} from 'react-cookie';
import {Loader} from '@flexe/ui-components';
import {useEffect} from 'react';
import {Warehouse} from '../../shared/CommonInterfaces';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import InboundsIndex from '../shared/index-page/InboundsIndex';

interface InboundsIndexProps {
  authenticityToken: string;
  selectedWarehouse: Warehouse;
  availableWarehouses: Warehouse[];
}

const InboundsApp: React.FC<InboundsIndexProps> = (props) => {
  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  const [selectedWarehouse, setSelectedWarehouse] = React.useState<Warehouse>(null);
  const [warehouseLoading, setWarehouseLoading] = React.useState<boolean>(true);
  const [cookies] = useCookies(['selected_warehouse_id']);

  useEffect(() => {
    const warehouseIdFromCookie = cookies.selected_warehouse_id ? Number(cookies.selected_warehouse_id) : null;
    let warehouseToSet: Warehouse = null;

    if (warehouseIdFromCookie) {
      warehouseToSet = props.availableWarehouses.find((warehouse) => warehouse.id === warehouseIdFromCookie);
    } else {
      warehouseToSet = props.availableWarehouses[0];
    }

    setSelectedWarehouse(warehouseToSet);
    setWarehouseLoading(false);
  }, [cookies.selected_warehouse_id, props.availableWarehouses]);

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <Router>
        <Switch>
          <Route
            path="/wh/inbounds"
            exact
            render={(routeProps) =>
              selectedWarehouse ? (
                <InboundsIndex {...routeProps} {...props} selectedWarehouse={selectedWarehouse} isShipper={false} />
              ) : (
                <Loader loading={warehouseLoading} />
              )
            }
          />
        </Switch>
      </Router>
    </FlexeContext.Provider>
  );
};

export default InboundsApp;
